import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import LayoutNavbar from "components/common/LayoutNavbar";
import Loading from "components/common/Loading";
import SearchFilterBox from "components/common/SearchFilterBox";
import { StyledTableCell, StyledTableRow } from "components/common/Table";
import useModalLoading from "libs/hooks/useModalLoading";
import usePagination from "libs/hooks/usePagination";
import HttpClient from "libs/utils/HttpClient";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getPersonalList } from "redux/modules/personalSlice";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(5),
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  tableContainer: {
    marginTop: theme.spacing(4),
  },
  pagination: {
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function PersonalListPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const modalLoading = useModalLoading();
  const [searchText, setSearchText] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const { list, isLoading } = useSelector((state) => state.personal);
  const userID = useSelector((state) => state.auth.userID);
  const [personal_data, setPersonal_data] = useState([]);
  const [kw_personal, setkw_personal] = useState("");
  const [txt_norec, setTxt_norec] = useState(false);

  const { jump, currentData, currentPage, maxPage } = usePagination(
    list || [],
    6
  );
  const dataList = currentData();

  useEffect(() => {
    dispatch(getPersonalList({ agentId: userID }));
  }, [dispatch, userID]);

  const handleOnSearch = (e) => setSearchText(e.target.value);

  const handleClickCancel = () => {
    setSearchText("");
    dispatch(getPersonalList({ keyword: "", agentId: userID }));
  };

  const handleClickSearch = () => {
    dispatch(getPersonalList({ keyword: searchText, agentId: userID }));
    modalLoading.showLoading();
  };

  const handleClickView = (detail) => () => {
    history.push(`/personal-detail/${detail.personalID}`);
  };

  const SearchPersonal = async () => {
    // console.log("hello");
    try {
      // const params = qs.stringify({
      //   ...(personalID && { personalID }),
      //   ...(Keyword && { Keyword }),
      //   ...(agentID && { agentID }),
      // });
      const response = await HttpClient.get(
        `/api/agency/personal/search?keyword=${kw_personal}`
      );
      console.log(response);

      if (response.status) {
        if (response.results.length !== 0) {
          setPersonal_data(response.results);
          console.log(response.results);
          setTxt_norec(true);
        } else {
          setPersonal_data([]);
          setTxt_norec(false);
        }
      } else {
        setPersonal_data([]);
        setTxt_norec(false);
      }
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  useEffect(() => {
    if (!isLoading) {
      modalLoading.hideLoading();
    }
  }, [modalLoading, isLoading]);

  return (
    <LayoutNavbar title="Agency / User">
      <Paper className={classes.card}>
        <ContentTitle subTitle="Smart Visa holders" title="Personal" />
        <Typography variant="body1">
          To “Add applicant account”, please note that the applicant account
          must be created first. After that, you can connect the applicant
          account to this account by adding the applicant’s email.
        </Typography>
        <SearchFilterBox
          searchValue={searchText}
          onSearch={handleOnSearch}
          onClickSearch={handleClickSearch}
          onClickCancel={handleClickCancel}
        />

        <Grid
          justify="space-between" // Add it here :)
          container
          spacing={24}
        >
          <Grid item>
            <ContentTitle
              subTitle="Search List"
              subTitleStyle={{ fontSize: 28 }}
            />
          </Grid>

          <Grid item>
            <div>
              <Button
                variant="contained"
                onClick={() => setOpenModal(true)}
                color="primary"
              >
                My Representative
              </Button>
            </div>
          </Grid>
        </Grid>
        <TableContainer className={classes.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHead}>PASSPORT</TableCell>
                <TableCell className={classes.tableHead}>FIRST NAME</TableCell>
                <TableCell className={classes.tableHead}>LAST NAME</TableCell>
                {/* <TableCell className={classes.tableHead}>
                  PHONE NUMBER
                </TableCell> */}
                <TableCell className={classes.tableHead}>ACTION</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataList.map((row) => (
                <StyledTableRow key={row.personalID}>
                  <StyledTableCell>{row.passportNumber || "-"}</StyledTableCell>
                  <StyledTableCell>{row.firstname || "-"}</StyledTableCell>
                  <StyledTableCell>{row.lastName || "-"}</StyledTableCell>
                  {/* <StyledTableCell>{row.mobile || "-"}</StyledTableCell> */}
                  <StyledTableCell>
                    <ColorButton
                      variant="contained"
                      color="info"
                      onClick={handleClickView(row)}
                    >
                      View
                    </ColorButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
              {isLoading && dataList.length === 0 && (
                <StyledTableRow>
                  <StyledTableCell colSpan={5}>
                    <Loading />
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          className={classes.pagination}
          page={currentPage}
          count={maxPage}
          color="primary"
          onChange={(__, toPage) => jump(toPage)}
        />

        <Button
          variant="contained"
          style={{ backgroundColor: "red", color: "white" }}
          size="large"
          href="/logout"
        >
          Logout
        </Button>
      </Paper>

      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>{"Search Personal "}</DialogTitle>
        <DialogContent>
          <TextField
            id="outlined-basic"
            value={kw_personal}
            onChange={(e) => {
              setkw_personal(e.target.value);
            }}
            style={{ marginRight: 5, width: 300 }}
            label="Email"
            variant="outlined"
          />
          <Button
            variant="contained"
            onClick={() => SearchPersonal()}
            color="primary"
            size="large"
          >
            Search
          </Button>
          <DialogContentText id="alert-dialog-description">
            {txt_norec ? (
              <TableContainer className={classes.tableContainer}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableHead}>Name</TableCell>
                      <TableCell className={classes.tableHead}>Email</TableCell>

                      {/* <TableCell className={classes.tableHead}>
                      PHONE NUMBER
                    </TableCell> */}
                      <TableCell className={classes.tableHead}>
                        ACTION
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {personal_data.map((row) => (
                      <StyledTableRow key={row.personalID}>
                        <StyledTableCell>
                          {row.firstName || "-"} {row.lastName || "-"}
                        </StyledTableCell>
                        <StyledTableCell>{row.email || "-"}</StyledTableCell>
                        {/* <StyledTableCell>{row.mobile || "-"}</StyledTableCell> */}
                        <StyledTableCell>
                          <ColorButton
                            variant="contained"
                            color="info"
                            onClick={() => {
                              setOpenModal(false);
                              Swal.fire({
                                title: "Confirm Personal ?",
                                text: "Email send to " + row.email + " Sure ?",

                                showCancelButton: true,
                                confirmButtonText: "Yes",
                              }).then(async (result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  try {
                                    const response = await HttpClient.post(
                                      "/api/agency/sendmailapproveagency",
                                      { personalID: row.personalID }
                                    );
                                    console.log(response);
                                    if (response.status) {
                                      Swal.fire(
                                        "Success !",
                                        "Check Email",
                                        "success"
                                      );
                                      setkw_personal("");
                                      setPersonal_data([]);
                                    } else {
                                      Swal.fire(
                                        "Error !",
                                        response.message,
                                        "error"
                                      );
                                      setkw_personal("");
                                      setPersonal_data([]);
                                    }
                                    if (response.status) return response;
                                    return Promise.reject(response);
                                  } catch (error) {
                                    // alert()
                                    const newError = error;
                                    throw newError;
                                  }
                                }
                              });
                            }}
                          >
                            Select
                          </ColorButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                    {isLoading && dataList.length === 0 && (
                      <StyledTableRow>
                        <StyledTableCell colSpan={5}>
                          <Loading />
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <>
                <p>No Record</p>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </LayoutNavbar>
  );
}

export default PersonalListPage;
